import React, { useState } from 'react'
import '../../assets/shared/recentWorks.css'

import img25 from "../../images/portfolio/updates/13-04-2026/ADELA_preview_still.jpg"
import img26 from "../../images/portfolio/updates/13-04-2026/Demi_Lovato_preview_still.jpg"
import img27 from "../../images/portfolio/updates/13-04-2026/Joji_preview_still.jpg"
import img28 from "../../images/portfolio/updates/13-04-2026/SANTOS_BRAVOS_preview_still.jpg"
import img29 from "../../images/portfolio/updates/13-04-2026/KELELA_preview_still.jpg"
import img30 from "../../images/portfolio/updates/13-04-2026/SwaeLee_preview_still.jpg"


import seeAllBtn from '../../images/portfolio/see_all.png';

import video25 from "../../videos/updates/13-04-2026/ADELA_preview.mp4"
import video26 from "../../videos/updates/13-04-2026/Demi_Lovato_preview.mp4"
import video27 from "../../videos/updates/13-04-2026/Joji_preview.mp4"
import video28 from "../../videos/updates/13-04-2026/SANTOS_BRAVOS_preview.mp4"
import video29 from "../../videos/updates/13-04-2026/KELELA_preview.mp4"
import video30 from "../../videos/updates/13-04-2026/SwaeLee_preview.mp4"

import meta from "../../store/meta"
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import play from '../../images/shared/showreel/play.svg'
import { isDesktop } from 'react-device-detect'

export const RecentWorks = observer(() => {
  const works = [
    {
      name: 'Swae Lee, Jhené Aiko - MURAL',
      full: 'Swae Lee, Jhené Aiko - MURAL',
      img: img30,
      video: video30,
      url: 'https://www.youtube.com/embed/xPrzm9UU4iE',
      director: ' Arrad',
      services: ' VFX, Animation',
      category: 'MUSIC VIDEO'
    }, {
      name: 'Kelela - idea 1',
      full: 'Kelela - idea 1',
      img: img29,
      video: video29,
      url: 'https://www.youtube.com/embed/U2IpeDPmjFo',
      director: ' 91 Rules',
      services: ' Cleanup, Beauty Retouching',
      category: 'MUSIC VIDEO'
    }, {
      name: 'SANTOS BRAVOS "KAWASAKI"',
      full: 'SANTOS BRAVOS "KAWASAKI"',
      img: img28,
      video: video28,
      url: 'https://www.youtube.com/embed/zkQI78ankMU',
      director: ' 91 Rules',
      services: ' VFX, Cleanup & Enhancement',
      category: 'MUSIC VIDEO'
    }, {
      name: 'Joji - Last of a Dying Breed / Dior',
      full: 'Joji - Last of a Dying Breed / Dior',
      img: img27,
      video: video27,
      url: 'https://www.youtube.com/embed/fV8bKLHKLYI',
      director: ' BRTHR',
      services: ' VFX, Animation',
      category: 'MUSIC VIDEO'
    }, {
      name: 'Demi Lovato - Kiss',
      full: 'Demi Lovato - Kiss',
      img: img26,
      video: video26,
      url: 'https://www.youtube.com/embed/FpOsFNaim00',
      director: ' 91 Rules',
      services: ' Cleanup, Beauty Retouching',
      category: 'MUSIC VIDEO'
    }, {
      name: 'ADÉLA - SexOnTheBeat',
      full: 'ADÉLA - SexOnTheBeat',
      img: img25,
      video: video25,
      url: 'https://www.youtube.com/embed/oCvdBnRj67k',
      director: ' 91 Rules',
      services: ' Cleanup, Beauty Retouching',
      category: 'MUSIC VIDEO'
    },
  ]
  const [hoveredId, setHoveredId] = useState(null)
  const navigate = useNavigate()

  const handleMouseEnter = (id) => {
    setHoveredId(id)
  };

  const handleMouseLeave = () => {
    setHoveredId(null)
  };

  return (
    <>
      <div className='recent-works container'>
        <div className='title-recent col'>
          <h2>RECENT</h2>
          <button onClick={() => navigate('/work')} className='see-all'><img src={seeAllBtn} alt="seeallbtn" /></button>
        </div>

        <div className='works-cont row'>
          {works.map(function (work, i) {
            return <div key={i} className='col-12 col-md-6 work-parent'>
              <div className='work-cont'>
                <div
                  className='image-cont'
                  onClick={() => meta.showVideo(work)}
                  onMouseEnter={() => handleMouseEnter(work.name)}
                  onMouseLeave={handleMouseLeave}
                  onTouchStart={() => handleMouseEnter(work.name)}
                  onTouchEnd={handleMouseLeave}
                >
                  <img
                    className='work-img'
                    src={work.img}
                    alt={work.url}
                  />
                  {isDesktop && hoveredId === work.name ? (
                    <video
                      className='work-img'
                      src={work.video}
                      autoPlay
                      loop
                      muted
                    />
                  ) : (
                    null
                  )}
                  <div
                    className='mask-cont'
                    style={{
                      opacity: isDesktop && hoveredId === work.name ? 1 : 0,
                    }}
                  >
                    <div className='corner1'></div>
                    <div className='corner2'></div>
                    <div className='title'>
                      {/* <h3>VIDEO {i + 1}:</h3> */}
                      <p>{work.name}</p>
                    </div>
                    <div className='play'>
                      <img src={play} alt='play' />
                      <span>CLICK TO PLAY</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
        <div className='see-all-btn-container'>
          <button onClick={() => navigate('/work')} className='see-all-mob'><img src={seeAllBtn} alt="seeallbtn" /></button>
        </div>
      </div>
    </>
  )
})
